import MessaggiRender from "../Messaggi/MessaggiRender.mjs";
import MessaggioRenderSegnalato from "./MessaggioRenderSegnalato.mjs";
import ModerateAction from "./ModerateAction.mjs";

const prefix="MessaggiRenderSegnalati";

const MessaggiRenderSegnalati = class extends MessaggiRender {
	constructor(props) {
		super(props);
		this.state.extra = props.extra || {};
		this.state.extra.axle = true;
	}
	render() {
		return (
			<div className={prefix+" MessaggiRender"}>
				{ (this.props.data || []).map( m => (
					<MessaggioRenderSegnalato
						key={`${m.id}-${m.updated}`}
						axle={this.props.axle}
						user={this.state.user}
						data={m}
						extra={ this.state.extra }
						lang={ this.state.lang }
						ll={ this.state.ll }
					/>
				)) }
				{ this.state.dettaglioSegnalazioni && (
					<ModerateAction user={this.state.user} data={ this.state.dettaglioSegnalazioni } />
				)}
			</div>
		)
	}
}

export default MessaggiRenderSegnalati;
